<template>
  <v-card>
    <v-form @submit.prevent="submitEditTrip()" ref="editTripForm">
      <v-container grid-list-lg>
        <v-layout row wrap>
          <dialog-header :title="'Edit'" :details="'Trip'"></dialog-header>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="Tip *"
              color="indigo"
              :prepend-icon="$store.state.global.pages.tip.icon"
              :items="filteredTips"
              @change="spoilId = null"
              item-text="name"
              item-value="id"
              v-model="tipId"
              :hint="tippingDocketRequiredHint"
              clearable
              :rules="tipRules"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm6>
            <v-autocomplete
              ref="spoilField"
              label="Spoil *"
              color="indigo"
              :prepend-icon="$store.state.global.pages.spoil.icon"
              :items="filteredSpoils"
              item-text="name"
              item-value="id"
              v-model="spoilId"
              :rules="spoilRules"
              clearable
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm4>
            <v-text-field
              autofocus
              type="number"
              color="indigo"
              label="Weighbridge/Tip Weight"
              prepend-icon="shopping_basket"
              v-model.number="editedTrip.siteWeight"
              :rules="siteWeightRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              type="number"
              color="indigo"
              label="LoadRite/Site Weight"
              prepend-icon="shopping_basket"
              v-model.number="editedTrip.tipWeight"
              :rules="tipWeightRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              type="number"
              color="indigo"
              label="Scale/Truck Weight"
              prepend-icon="shopping_basket"
              v-model.number="editedTrip.scaleWeight"
              :rules="scaleWeightRules"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <time-picker-wrapper v-model="editedTrip.start" label="Start Time"></time-picker-wrapper>
          </v-flex>
          <v-flex xs12 sm6>
            <time-picker-wrapper v-model="editedTrip.end" label="End Time"></time-picker-wrapper>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              type="number"
              color="indigo"
              label="Quantity"
              prepend-icon="shopping_basket"
              v-model.number="editedTrip.qty"
              :rules="qtyRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              type="number"
              color="indigo"
              label="Breaks"
              prepend-icon="alarm_off"
              v-model.number="editedTrip.breaks"
              :rules="breaksRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              type="number"
              color="indigo"
              label="Travel"
              prepend-icon="add_alarm"
              v-model.number="editedTrip.travel"
              :rules="travelRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              color="indigo"
              label="W/B Docket #"
              prepend-icon="note"
              v-model="editedTrip.wbDocketNumber"
              :rules="wbDocketNumberRules"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm8>
            <v-text-field
              color="indigo"
              label="Trip Notes"
              prepend-icon="note"
              v-model="editedTrip.notes"
              :rules="noteRules"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn color="grey darken-2" flat @click="discard()">Discard?</v-btn>
          <v-btn color="green" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn color="grey darken-2" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";

// MIXINS
import TripValidation from "@/services/validation/tripValidation";
import FilterTipSpoils from "@/services/mixins/filterTipSpoils";
import TripShared from "./mixins/tripShared";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";
import TimePickerWrapper from "@/components/ui/timePickerWrapper";

export default {
  mixins: [TripValidation, FilterTipSpoils, TripShared],
  components: {
    DialogHeader,
    TimePickerWrapper
  },
  data() {
    return {
      editedTrip: null,
      loading: false,
      prefix: "editedTrip",
      tipId: null,
      spoilId: null,
      projectId: null
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedTrip = Object.assign({}, this.trip);
      this.close();
    },
    submitEditTrip() {
      if (!this.$refs.editTripForm.validate()) {
        return;
      }
      this.save();
    },
    save() {
      this.editedTrip.tip = this.tipObj;
      this.editedTrip.spoil = this.spoilObj;
      this.editedTrip.tipId = this.tipId;
      (this.editedTrip.spoilId = this.spoilId),
        this.$store.commit("dockets/updateArrayStateByValue", {
          prop: "trips",
          value: this.trip,
          editedValue: this.editedTrip
        });
      this.snack({ color: "green", text: "Trip was edited" });
      this.close();
    }
  },
  computed: {
    //GET SELECTED ALLOCATION FROM STORE
    selectedAllocation: Store.getSet({
      store: "dockets",
      prop: "selectedAllocation"
    }),
    different() {
      if (!this._.isEqual(this.trip, this.editedTrip)) {
        return true;
      } else {
        return false;
      }
    },
    tips: Store.getSet({ store: "tips", prop: "tips" }),
    spoils: Store.getSet({ store: "spoils", prop: "spoils" }),
    siteObj: Store.getSet({ store: "dockets", prop: "siteObj" })
  },
  mounted() {
    (this.editedTrip = Object.assign({}, this.trip)),
      (this.tipId = this.editedTrip.tipId);
    (this.spoilId = this.editedTrip.spoilId),
      (this.projectId = this.siteObj.projectId);
    console.log('PROJECT ID FROM DOCKET / EDIT TRIP', this.projectId)
    // this.editedTrip = Object.assign({}, this.trip),
    // this.tipId = this.editedTrip.tipId
    // this.spoilId = this.editedTrip.spoilId,
    // this.projectId = this.siteObj.projectId

  },
  props: {
    trip: Object
  },
};
</script>

<style>
</style>
